// extracted by mini-css-extract-plugin
export default {"About":"About_About__wA1wa","content":"About_content__sEuTc","email":"About_email__cjYYm"};